import postActionsView from './postActionsComponent.html';
import './postActionsComponent.css';
import moment from 'moment/moment';
import _ from 'lodash';
import { PostTypes } from '../postType/PostTypesEnum.js';
import { AuthTypes } from '../../auth/AuthTypes.js';
import PostAction from '../../../../../a-react-app/src/_common/domain/enums/PostAction.js';

export function postActionsComponent() {
	return {
		bindings: {
			post: '=',
			isDetailScreen: '<?',
		},
		controllerAs: 'vm',
		controller: postActionsComponentCtrl,
		template: postActionsView,
	};
}

export class postActionsComponentCtrl {
	constructor($rootScope, Api, Cfg, Post, modal, Identity, Att, Theme, MsalAuth) {
		'ngInject';
		this.$rootScope = $rootScope;
		this.Api = Api;
		this.Cfg = Cfg;
		this.Post = Post;
		this.modal = modal;
		this.Identity = Identity;
		this.Att = Att;
		this.Theme = Theme;
		this.MsalAuth = MsalAuth;
	}

	$onInit() {
		this._checkPermissions();
		this.isResearchBrief = this.post && this.post.type && this.post.type.id === PostTypes.research_brief;
		this.isSecretPostLink = !!AuthTypes.getSecretPostHash();
	}

	_checkPermissions() {
		this.hasMultipleHubs = this.Identity.hasMultipleHubs();
		this.isMyPost = this._isSubmitterOrPublisher();
		this.hasSlackConnection = this.Cfg.read('Slack.has_connection');
		this.hasMsTeamsConnection = this.Cfg.read('MsTeams.has_connection');
		this.archiveEnabled = this.Cfg.read('PostArchive.enable_archive') == 1;
		this.showPublicLink = this.Cfg.readAsBool('Features.public_post_link');
		this.showPushToPowerPoint = parseInt(this.Cfg.read('Features.push_to_powerpoint'), 10) === 1;
		this.showToClientsUsers = this.Cfg.readAsBool('UI.post_show_clients_users');
		// CHECK IF PRIVATE LINK SSO IS ENABLED, IF SO GRAB SP CODE
		this.ssoPrivateLinkEnabled = this.Cfg.readAsBool('Features.use_sso_post_link');
		this.privateLinkSpCode = this.Cfg.read('Features.sso_post_link_sp');
		this.can = {};
		let currentClientId = this.Identity.currentClient().id;
		let postHubId = this.post && this.post.hub ? parseInt(this.post.hub.id) : currentClientId;
		let isSameHub = currentClientId === postHubId;
		[
			'manage_client_intel',
			'delete_post',
			'copy_posts',
			'push_to_powerpoint',
			'send_email',
			'edit_stories',
			'edit_post',
			'login',
		].forEach(perm => {
			this.can[perm] = this.Identity.can(perm);
		});

		this.can.sharePost = (this.post.allowedActions || []).length > 0;
		this.can.shareViaPowerPoint = this.post.allowedActions.includes(PostAction.CreatePowerpointSlide);
		this.can.shareViaEmailBrief = this.post.allowedActions.includes(PostAction.ShareViaEmailBrief);
		this.can.addToInsightBrief = this.post.allowedActions.includes(PostAction.AddToInsightBrief);
		this.can.shareViaPublicLink = this.post.allowedActions.includes(PostAction.ShareViaPublicLink);
		this.can.shareViaPrivateLink = this.post.allowedActions.includes(PostAction.ShareViaPrivateLink);
		this.can.pushToSlack = this.post.allowedActions.includes(PostAction.PushToSlack);
		this.can.pushToMicrosoftTeams = this.post.allowedActions.includes(PostAction.PushToMicrosoftTeams);
		this.can.download = this.post.allowedActions.includes(PostAction.Download);

		if (this.Identity.isSuperadmin()) {
			this.can.all = true;
		}

		// If you can't edit but the post was made by you, set the permission to true
		if (!this.can.edit_post && this.isMyPost) {
			this.can.edit_post = true;
		}

		// If you can't delete but the post was made by you, set the permission to true
		if (!this.can.delete_post && this.isMyPost) {
			this.can.delete_post = true;
		}

		// If you are NOT in the same hub as the post you are looking at, change some permissions of the post.
		if (!isSameHub) {
			this.can.edit_post = false;
			this.can.delete_post = false;
			this.can.push_to_powerpoint = false;
			this.can.edit_stories = false;
			this.can.send_email = false;
		}
	}

	_isSubmitterOrPublisher() {
		const myId = this.Identity.user().id;
		return (
			(this.post.submitted_by && this.post.submitted_by.id == myId) ||
			(this.post.published_by && this.post.published_by.id == myId)
		);
	}

	updatePost() {
		this.Api.get(`/v3/posts/${this.post.id}`).then(post => {
			_.extend(this.post, post);
			this.post.modified_at = moment().format();
		});
	}

	updateArchivedPost() {
		this.Api.get(`/v3/posts/${this.post.id}`, {
			include_deleted: true,
			archive_action: this.post.archive_action ? this.post.archive_action : 'archive',
		}).then(post => {
			_.extend(this.post, post);
			this.post.modified_at = moment().format();
		});
	}

	toggleClientVisibility() {
		this.post.is_client_intel = !this.post.is_client_intel;
		this.Api.patch(`/posts/${this.post.id}`, {
			is_client_intel: this.post.is_client_intel,
		});
	}

	togglePinning() {
		if (this.post.is_pinned) {
			this.Api.post(`/v2/posts/${this.post.id}/priority/unpin`).then(res => {
				if (res.success) {
					this.post.is_pinned = false;
					this.$rootScope.$broadcast('post-unpin', { post: this.post });
				} else {
					this.modal.alert({ text: res.message });
				}
			});
		} else {
			this.Api.post(`/v2/posts/${this.post.id}/priority/pin`).then(res => {
				if (res.success) {
					this.post.is_pinned = true;
					this.$rootScope.$broadcast('post-pin', { post: this.post });
				} else {
					this.modal.alert({ text: res.message });
				}
			});
		}
	}

	delete() {
		this.Post.confirmDelete(this.post);
	}

	directLink() {
		let link = `${window.BASE_URL}/p/${this.post.id}`;
		if (this.ssoPrivateLinkEnabled) {
			// New URL layout: https://sharpr.com/p/123?sso=uhc-23498d-sp
			link += `?sso=${this.privateLinkSpCode}`;
		}
		const alert = `
        <input type="text" class="form-input full-width" value="${link}">
        <br><br>
        <strong>Note:</strong> Users must log in before accessing this post.
    `;
		let options = { escapedHtml: alert, heading: 'Direct link to post' };
		this.modal.text(options).focus();
	}

	async secretPublicLink() {
		let hash = '';
		const getResp = await this.Api.request('get', `/v2/posts/${this.post.id}/secret_links`);
		//We don't have one so we need to create one
		if (getResp.status === 404) {
			const createResp = await this.Api.request('post', `/v2/posts/${this.post.id}/secret_links`);
			if (createResp.status === 200 || createResp.status === 201) {
				hash = createResp.data.hash;
			}
		} else if (getResp.status === 200) {
			hash = getResp.data.hash;
		}

		if (hash) {
			this.secretLink = `${window.BASE_URL}/link/${hash}`;
		} else {
			this.modal.alert({ text: 'Error getting post link' });
		}
	}

	createPptSlide() {
		let msg = `
			Generating <img src="/angular/assets/img/loaders/indeterminate.gif" alt="" height="19" width="220">
		`;
		let modal = this.modal.alert({
			text: msg,
			heading: 'Creating PowerPoint Slide',
			timeoutMs: 30000,
		});
		let url = `/powerpoint/post/${this.post.id}`;

		let img = new Image();
		img.onload = img.onerror = () => modal.close();
		img.src = url;

		window.location.href = url;
	}

	pushToEmail() {
		window.location.href = `/posts/email_publish/?post[${this.post.id}]=1`;
	}

	archive() {
		const updateArchivedPost = this.updateArchivedPost.bind(this);
		this.Post.confirmArchive(this.post).then(updateArchivedPost);
	}

	edit() {
		const update = this.updatePost.bind(this);
		this.Post.edit(this.post).then(update, update);
	}

	unarchive() {
		const update = this.updatePost.bind(this);
		const updateArchivedPost = this.updateArchivedPost.bind(this);
		this.Post.unarchive(this.post.id).then(update, updateArchivedPost);
	}

	copy() {
		this.modal.state('hub.loggedin.PostCopy', {
			params: { id: this.post.id },
			heading: 'Copy Post',
			width: 600,
			height: 'full',
		});
	}

	viewFullscreen() {
		this.Post.viewFullscreen(this.post);
	}

	testFullText() {
		const options = {
			heading: 'Search post content',
			text: 'Enter text to search for:',
			submitOnEnter: true,
			confirmText: 'Search',
		};
		this.modal.prompt(options).then(text => {
			if (!text) {
				return;
			}
			const params = {
				post_id: this.post.id,
				term: text,
			};
			this.Api.post('/nosql/test/post', params).then(result => {
				const msg = `
					<b>Post is indexed?</b> ${result.isIndexed ? 'Yes' : 'No'}<br>
					<b>"${text}" matches post?</b> ${result.doesMatch ? 'Yes' : 'No'}
				`;
				this.modal.alert({ escapedHtml: msg, heading: 'Result' });
			});
		});
	}

	fileStatus() {
		this.modal.state('hub.loggedin.FileStatus', {
			heading: 'File Processing Status',
			params: { postId: this.post.id },
			width: 'full',
			height: 'full',
		});
	}

	reindexElastic() {
		this.Api.post(`/posts/${this.post.id}/reindex`).then(result => {
			this.modal.alert({ text: result.message });
		});
	}

	pushToSlack() {
		this.modal.state('hub.loggedin.SlackPost', {
			heading: 'Push to Slack',
			params: { postId: this.post.id },
			width: 550,
			height: 550,
		});
	}

	async pushToMsTeams() {
		let accessToken = null;
		try {
			accessToken = await this.MsalAuth.getAccessToken();
		} catch (err) {}

		this.modal
			.state('hub.loggedin.MsTeamsPost', {
				heading: 'Push to Microsoft Teams',
				params: { post: this.post, accessToken },
				width: 550,
				height: 550,
			})
			.catch(err => {
				if (err !== 'X') {
					console.error(err);
				}
			});
	}
}
